import { ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core'
import { UntypedFormBuilder } from '@angular/forms'
import { CurrentProductService, ProductReviewsComponent } from '@spartacus/storefront'
import { distinctUntilChanged, filter, map, switchMap, tap } from 'rxjs/operators'
import { MbProductReviewsConnector } from '../../../connectors'
import { isNotNullable, ProductReviewService } from '@spartacus/core'

@Component({
  selector: 'mb-pdp-reviews-tab',
  templateUrl: './pdp-reviews-tab.component.html',
  styleUrls: ['./pdp-reviews-tab.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PdpReviewsTabComponent extends ProductReviewsComponent {

  initialMaxListItems = 3
  mbReviewData$ = this.product$?.pipe(
    map(product => product?.originalCode),
    filter(isNotNullable),
    distinctUntilChanged(),
    switchMap(productCode => this.mbProductReviewsConnector.get(productCode)),
    tap(() => this.maxListItems = this.initialMaxListItems)
  )

  constructor (protected reviewService: ProductReviewService,
              protected currentProductService: CurrentProductService,
              fb: UntypedFormBuilder,
              protected cd: ChangeDetectorRef,
              protected mbProductReviewsConnector: MbProductReviewsConnector) {
    super(reviewService, currentProductService, fb, cd)
  }
}
